<template>
    <div class="center">
        <modal identifier="leaveeditquestion" ref="question" :question="question" :cancelText="cancelText" :confirmText="confirmText" :showTrigger="false"  v-on:onConfirm="okClicked()" v-on:onCancel="cancelClicked()" confirmButtonClass="green"/>
        <table class="hiddenprint" v-if="loaded == false">
            <preloader />
        </table>
         <table class="hiddenprint" v-if="error && loaded">
            Wystąpił błąd podczas ładowania obiektu.
        </table>
        <div v-if="loaded && !error" class="hiddenprint">
            <div class="row redframe" style="padding-right: 0.4rem; margin-top: 5px;">
                <div class="col s6 input-field">
                    {{$t('places.name')}}
                    <input id="place_name" v-model="place.name" :placeholder=place.displayedname :disabled="edit==false"  v-on:click="startEditField()"/>
                </div>
                <div class="col s3 input-field">
                    {{$t('customers.status')}}
                    <select id="place_status" class="browser-default" v-model="place.status" :disabled="edit==false">
                        <option value="active">{{$t('customers.status_active')}}</option>
                        <option value="inactive">{{$t('customers.status_inactive')}}</option>
                        <option value="suspended">{{$t('customers.status_suspended')}}</option>
                    </select>
                </div>
                <div class="col s3 input-field">
                    {{$t('customers.tags')}}
                    <input id="place_tags"  v-model="place.tags" :disabled="edit==false" />
                </div>
            </div>
            <div class="row">
                <div class="col s1 rightlabel">
                    {{$t('place.name')}}
                </div>
                <div class="col input-field" :class="{ s10: !place.any_devices, s11: place.any_devices }">
                    <div class="input-field">
                        <input  id="place_displayedname" v-model="place.displayedname" :placeholder=place.name :disabled="edit==false" />
                    </div>
                </div>
                <div class="col s1" v-if="!place.any_devices">
                    <modal :question="$t('place.remove_question')" :confirmText="$t('menu.buttons.delete')" identifier="placeremovequestion" v-on:onConfirm="rmObject()" />
                </div>
            </div>
            <template v-if="place.address != undefined">
                <div class="row">
                    <div class="col s1 rightlabel">
                         {{$t('place.address')}}
                     </div>
                    <div class="col s3">
                        <div class="input-field">
                            <input id="place_address_street" v-model="place.address.street" :disabled="edit==false" />
                        </div>
                    </div>
                    <div class="col s1 rightlabel">
                        {{$t('place.city')}}
                    </div>
                    <div class="col s3">
                        <div class="input-field">
                            <input id="place_address_city" v-model="place.address.city" :disabled="edit==false" />
                        </div>
                    </div>
                    <div class="col s2 rightlabel">
                        {{$t('place.postal_code')}}
                    </div>
                    <div class="col s2">
                        <div class="input-field">
                            <input id="place_address_postalcode" v-model="place.address.postal_code" :disabled="edit==false" />
                        </div>
                    </div>
                </div>
                <div class="row" v-if="role != 'ddd_customer'">
                    <div class="col s2 rightlabel">
                        {{$t('place.estimated_time')}}
                    </div>
                    <div class="col s2">
                        <div class="input-field">
                            <input id="place_estimated_time" v-model="place.estimated_time" :disabled="edit==false" />
                        </div>
                    </div>
                    <div class="col s4">
                        <div class="input-field">
                            <input id="place_misc" v-model="place.misc" :disabled="edit==false" />
                        </div>
                    </div>
                </div>
            </template>
            <div class="row">
                <div class="col  offset-l8 s4 l2">
                    <a v-on:click="cancel()" class="waves-effect waves-light btn-large cancelbutton" v-if="edit == true">{{$t('menu.buttons.cancel_changes')}}</a>
                </div>
                <div class="col l2 s4">
                    <a v-on:click="startEdit()" class="waves-effect waves-light btn-large emptygreen" v-if="edit == false && place.editable">{{$t('menu.buttons.edit')}}</a>
                    <a v-on:click="save()" class="waves-effect waves-light btn-large emptygreen" v-if="edit">
                        <div v-if="saving" class="preloader-wrapper small active">
                            <div class="spinner-layer spinner-red-only">
                                <div class="circle-clipper left">
                                    <div class="circle"></div>
                                </div>
                                <div class="gap-patch">
                                    <div class="circle"></div>
                                </div>
                                <div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                            </div>
                        </div>
                        {{saving == false ? $t('menu.buttons.save_changes') : ""}}
                    </a>
                </div>
            </div>
        </div>
        <template v-if="loaded && !error">
        <collapsible :title='$t("place.inspections")' :active="place.id != undefined">
            <placeinspections v-if="loaded && place.id != undefined" :customer_id="customer_id" :place_id="place_id" :last_date="place.inspection_last" :editable="place.editable" :role="role"/>
        </collapsible>
        <collapsible v-if="loaded && place.inner_inspections" :title='$t("place.inner_inspections")' :active="place.id != undefined">
            <innerinspections ref="innerinspections" :customer_id="customer_id"  :place="place" v-if="loaded && place.id"></innerinspections>
        </collapsible>
        <collapsible :title='$t("place.recommendations")' :active="place.id != undefined">
            <placerecommendations :editable="place.editable" v-if="loaded && place.id != undefined" :customer_id="customer_id" :place_id="place_id" ref="recommendations" />
        </collapsible>
        <collapsible :title='$t("place.routine_analyses")' :active="place.id != undefined">
            <placeanalyses v-if="loaded && place.id != undefined" :customer_id="customer_id" :place_id="place_id" :place="place" :last_date="place.inspection_last" />
        </collapsible>
        <collapsible :title='$t("place.primary_inspections")' :active="place.id != undefined">
            <placeprimaryinspections v-if="loaded && place.id != undefined" :customer_id="customer_id" :place_id="place_id" :place="place" />
        </collapsible>
        <collapsible :title='$t("place.devices")' :active="place.id != undefined">
            <devices ref="devices" :editable="place.editable" :place="place" v-if="loaded && place.id" :place_id="place.id" :customer_id="customer_id"></devices>
        </collapsible>

        <collapsible :title='$t("place.details")' :active="place.id != undefined">
            <div class="row">
                <div class="col s3 input-field right-align">
                    {{$t('place.details_form.total_area')}}
                </div>
                <div class="col s1 input-field left-align">
                    <div class="input-field inline">
                        <input id="place_total_area" v-model="place.total_area" :disabled="edit==false" />
                    </div>
                </div>
                <div class="col s1 input-field left-align">
                    <div class="input-field inline">
                        <select id="place_total_area_units" v-model="place.total_area_units" class="browser-default" :disabled="edit==false">
                            <option value="m²">m²</option>
                            <option value="ha">ha</option>
                            <option value="a">a</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col s3 input-field right-align">
                     {{$t('place.details_form.buildup_area')}}
                </div>
                <div class="col s1 input-field left-align">
                    <div class="input-field inline">
                        <input id="place_build_area" v-model="place.building_area" :disabled="edit==false" />
                    </div>
                </div>
                <div class="col s1 input-field left-align">
                    <div class="input-field inline">
                        <select id="place_build_area_units" v-model="place.building_area_units" class="browser-default" :disabled="edit==false">
                            <option value="m²">m²</option>
                            <option value="ha">ha</option>
                            <option value="a">a</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col s3 input-field right-align">
                    {{$t('place.details_form.building_type')}}
                </div>
                <div class="col s6 input-field left-align">
                    <div class="input-field inline" style="width: 100%">
                        <selector v-model="place.building_types" v-bind:items="building_types_list" v-bind:identifier="'building_type'" :disabled="edit==false" :elongating=true></selector>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col s3 input-field right-align">
                    {{$t('place.details_form.surrounding')}}
                </div>
                <div class="col s6 input-field left-align">
                    <div class="input-field inline" style="width: 100%">
                        <selector v-model="place.neighbour_buildings" v-bind:items="neighbours" v-bind:identifier="'neighbourhood'" :disabled="edit==false" :elongating=true></selector>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col s3 input-field right-align">
                    {{$t('place.details_form.business_profile')}}
                </div>
                <div class="col s3 input-field left-align">
                    <div class="input-field inline" style="width: 100%">
                        <input id="place_economic_activity" v-model="place.economic_activity" :disabled="edit==false" style="width: 100%;" />
                    </div>
                </div>
                <div class="col s2 input-field left-align">
                    <label>
                        <input id="place_economic_activity_food"  type="checkbox" checked="checked" />
                        <span>{{$t('place.details_form.food_industry')}}</span>
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col s3 input-field right-align">
                    {{$t('place.details_form.quality_standard')}}
                </div>
                <div class="col s6 input-field left-align">
                    <div class="input-field inline" style="width: 100%;">
                        <selector v-model="place.standards" v-bind:items="standards" v-bind:identifier="'standard'" :disabled="edit==false" :elongating=true></selector>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col s3 input-field right-align">
                     {{$t('place.details_form.distance')}}
                </div>
                <div class="col s6 input-field left-align">
                    <div class="input-field inline">
                        <input id="place_distance"  v-model="place.distance" :disabled="edit==false" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col  offset-l8 s4 l2">
                    <a v-on:click="cancel()" class="waves-effect waves-light btn-large cancelbutton" v-if="edit == true">{{$t('menu.buttons.cancel_changes')}}</a>
                </div>
                <div class="col l2 s4">
                    <a v-on:click="startEdit()" class="waves-effect waves-light btn-large emptygreen" v-if="edit == false && place.editable">{{$t('menu.buttons.edit')}}</a>
                    <a v-on:click="save()" class="waves-effect waves-light btn-large solidgreen" v-if="edit">
                        <div v-if="saving" class="preloader-wrapper small active">
                            <div class="spinner-layer spinner-red-only">
                                <div class="circle-clipper left">
                                    <div class="circle"></div>
                                </div>
                                <div class="gap-patch">
                                    <div class="circle"></div>
                                </div>
                                <div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                            </div>
                        </div>
                        {{saving == false ? $t('menu.buttons.save_changes') : ""}}
                    </a>
                </div>
            </div>
        </collapsible>
        <collapsible :title='$t("place.documents")' :active="place.id != undefined">
            <div class="row" style="padding-bottom: 25px;">
                <template v-if="getDocuments.length > 0">
                    <div class="col s2 leftlabel">{{$t('documents.date_of_issue')}}</div>
                    <div class="col s3 leftlabel">{{$t('documents.name')}}</div>
                    <div class="col s3 leftlabel">{{$t('documents.description')}}</div>
                    <div class="col s2 leftlabel">{{$t('documents.document_type')}}</div>
                </template>
                <div class="col s2 right-align" v-bind:class="{'offset-s10': (getDocuments.length == 0)}" v-if="place.editable">
                    <a v-on:click="addDocument()" class="waves-effect waves-light btn-small green">Dodaj dokument</a>
                </div>
            </div>
            <div class="row" v-for="(doc, index) in getDocuments" v-show="!doc._destroy" :key="index">
                <div class="col s2 input-field">
                    <input :id="'place_doc_'+index+'_date'" type="date" class="datepicker" v-model="doc.date" :disabled="editdocuments == false">
                </div>
                <div class="col s3  input-field">
                    <input :id="'place_doc_'+index+'_name'" v-model="doc.name" :disabled="editdocuments == false" />
                </div>
                <div class="col s3  input-field">
                    <input :id="'place_doc_'+index+'_comment'"  v-model="doc.comment" :disabled="editdocuments == false" />
                </div>
                <div class="col s2 selectorignored">
                    <select :id="'place_doc_'+index+'_doctype'"  v-model="doc.doctype" :disabled="editdocuments == false">
                        <option value="pzs">{{$t('documents.types.pzs')}}</option>
                        <option value="agreement">{{$t('documents.types.agreement')}}</option>
                        <option value="agreement_annex">{{$t('documents.types.agreement_annex')}}</option>
                        <option value="instruction">{{$t('documents.types.instruction')}}</option>
                        <option value="other">{{$t('documents.types.other')}}</option>
                    </select>
                </div>
                <div class="col s1" style="padding-top: 5px; text-align: left;">
                    <label :for="'docfile'+index"  v-if="!doc.attachment">
                        {{ doc.file == undefined ? "Wybierz plik" : doc.file.name }}
                    </label>
                    <input type="file" :id="'docfile'+index" @change="setFile(doc, $event.target.name, $event.target.files)" v-if="!doc.attachment" :disabled="editdocuments == false" hidden />
                    <a :href="doc.attachment" v-if="doc.attachment"><i class="material-icons">insert_drive_file</i></a>
                </div>
                 <div class="col s1">
                    <a v-on:click="removeDocument(doc)" class="waves-effect waves-light btn-small red" v-if="editdocuments == true">{{$t('menu.buttons.delete')}}</a>
                </div>
            </div>
            <div class="row" style="margin-bottom: 8px; margin-top: 8px;">
                <div class="col s6 offset-l6 l3 right-align ">
                    <a v-on:click="cancelEditDocuments()" class="waves-effect waves-light btn-large cancelbutton" v-if="editdocuments == true">{{$t('menu.buttons.cancel_changes')}}</a>
                </div>
                <div class="col s6 l3">
                    <a v-on:click="editDocuments()" class="waves-effect waves-light btn-large emptygreen" v-if="editdocuments == false && getDocuments.length > 0 && place.editable">
                        <template>{{$t('menu.buttons.edit')}}</template>
                    </a>
                    <a v-on:click="saveDocuments()" class="waves-effect waves-light btn-large emptygreen" v-if="editdocuments">
                        <div v-if="savingdocuments" class="preloader-wrapper small active">
                            <div class="spinner-layer spinner-red-only">
                                <div class="circle-clipper left">
                                    <div class="circle"></div>
                                </div>
                                <div class="gap-patch">
                                    <div class="circle"></div>
                                </div>
                                <div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                            </div>
                        </div>
                        {{savingdocuments == false ? $t('menu.buttons.save_changes') : ""}}
                    </a>
                </div>
            </div>
        </collapsible>
        <collapsible :title='$t("place.plans")' :active="place.id != undefined">
            <placeplans :place="place"/>
        </collapsible>
        <collapsible :title='$t("place.contacts")' :active="place.id != undefined">
            <template v-for="contact in place.contacts">
                
                <div class="row">
                    <div class="col s11">
                        <div class="row" style="border-top-style: groove;border-left-style: groove;border-right-style: groove; padding-top: 1em;">
                            <div class="col s6 label">
                                <autosizelabel :text='$t("contacts.first_last_name")' />
                                <div class="input-field">
                                    <input :disabled="!editcontacts" v-model="contact.name">
                                </div>
                            </div>
                            <div class="col s6">
                                <autosizelabel :text='$t("contacts.position")' />
                                <div class="input-field">
                                    <input :disabled="!editcontacts" v-model="contact.position">
                                </div>
                            </div>
                        </div>
                        <div class="row" style="border-bottom-style: groove;border-left-style: groove;border-right-style: groove;margin-bottom: 1em !important;">
                            <div class="col s3" v-bind:class="contact.errors && contact.errors.email ?  'errors' : ''">
                                <autosizelabel :text='$t("contacts.email")' />
                                <div class="input-field inline">
                                    <input :disabled="!editcontacts" v-model="contact.email">
                                </div>
                                <span v-if="contact.errors && contact.errors.email">{{contact.errors.email.join(" ")}}</span>
                            </div>
                            <div class="col s3">
                                <autosizelabel :text='$t("contacts.phone")' />
                                <div class="input-field inline">
                                    <input :disabled="!editcontacts" v-model="contact.phone">
                                </div>
                            </div>
                            <div class="col s3">
                                <autosizelabel :text='$t("contacts.phone")' />
                                <div class="input-field inline">
                                    <input :disabled="!editcontacts" v-model="contact.phone_other">
                                </div>
                            </div>
                            <div class="col s3">
                                <label>
                                    <input :disabled="!editcontacts" type="checkbox" v-model="contact.display_on_app" checked="checked" value="true" />
                                    <span>{{$t("contacts.show_mobile_app")}}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <!-- "Czy chcesz usunąć kontakt ?" -->
                    <div class="col s1">
                        <modal :question="$t('place.remove_contact_question')" :confirmText="$t('menu.buttons.delete')" identifier="placecontactremovequestion" v-on:onConfirm="removeContact(contact)" v-if="editcontacts == true" />
                    </div>
                </div>
            </template>
            <div class="row" v-if="place.editable">
                <div class="col s3" style="margin-bottom: 15px;">
                    <a v-on:click="addContact()" class="waves-effect waves-light btn-large green">{{$t('place.add_contact')}}</a>
                </div>
                <div class="col offset-s5 s2">
                    <a v-on:click="cancelEditContacts()" class="waves-effect waves-light btn-large cancelbutton" v-if="editcontacts == true">{{$t('menu.buttons.cancel_changes')}}</a>
                </div>
                <div class="col s2">
                    <a v-on:click="editContacts()" class="waves-effect waves-light btn-large emptygreen" v-if="editcontacts == false && place.contacts.length > 0 && place.editable">
                        {{$t('menu.buttons.edit')}}
                    </a>
                    <a v-on:click="saveContacts()" class="waves-effect waves-light btn-large emptygreen" v-if="editcontacts">
                        <div v-if="saving" class="preloader-wrapper small active">
                            <div class="spinner-layer spinner-red-only">
                                <div class="circle-clipper left">
                                    <div class="circle"></div>
                                </div>
                                <div class="gap-patch">
                                    <div class="circle"></div>
                                </div>
                                <div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                            </div>
                        </div>
                        {{saving == false ? $t('menu.buttons.save_changes') : ""}}
                    </a>
                </div>
            </div>
        </collapsible>
        <collapsible :title='$t("place.interventions")' :active="place.id != undefined">
            <placeinterventions v-if="loaded && place.id" :customer_id="customer_id" :place_id="place_id" />
        </collapsible>
        <collapsible :title='$t("place.installations")' :active="place.id != undefined">
            <placeinstallations v-if="loaded && place.id" :customer_id="customer_id" :place_id="place_id" />
        </collapsible>
        <collapsible :title='$t("place.inspection_procedures")' :active="place.id != undefined">
            <div class="row" style="text-align: left;">
                <div class="col m12 label">
                    <autosizelabel :text='$t("inspection_procedures.task_info")' />
                    <div class="input-field inline" style="width: 70%"><textarea id="place_info" v-model="place.info" :disabled="!edit"></textarea></div>
                </div>
            </div>
            <div class="row" style="text-align: left;">
                <div class="col m6 label">
                    <label>
                        <input type="checkbox" v-model="place.helping_questions" :disabled="!edit"/>
                        <span>{{$t("inspection_procedures.questions")}}</span>
                    </label>
                </div>
            </div>
            <template v-if="place.helping_questions">
            <div v-for="question in place.questions" class="selectorignored">
                <div class="row" v-if="!question._destroy">
                    <div class="col s2">
                        {{$t("inspection_procedures.question")}}
                    </div>
                    <div class="col s6">
                        <div class="input-field">
                            <input v-model="question.text" :disabled="!edit" />
                        </div>
                    </div>
                    <div class="col s2">
                        <input type="checkbox" v-model="question.yes_generate_recommendation" :disabled="!edit" />
                        <label>
                            <input type="checkbox" v-model="question.yes_generate_recommendation" :disabled="!edit" />
                            <span>{{$t("inspection_procedures.generate_recommendation")}}</span>
                        </label>
                    </div>
                    <div class="col s1">
                        <modal :question="$t('place.remove_question_question')" :confirmText="$t('menu.buttons.delete')" identifier="removeQuestionDialog" v-on:onConfirm="removeQuestion(question)" v-if="edit">{{$t('place.remove_question_question_rich')}}</modal>
                    </div>
                </div>
                <div class="row" v-if="question.yes_generate_recommendation && !question._destroy">
                    <div class="col s9" style="border: 1px solid; padding-top: 15px; padding-left: 15px; padding-bottom: 5px;margin-bottom: 15px;">
                        <div class="row">
                            <div class="col  s1">{{$t("inspection_procedures.description")}}</div>
                            <div class="col s11">
                                <div class="input-field"><input v-model="question.yes_recommendation_problem" placeholder="Opisz problem" v-if="question.yes_generate_recommendation" :disabled="!edit" /></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col s2">{{$t("inspection_procedures.cause")}}</div>
                            <div class="col s10">
                                <div class="input-field"><input v-model="question.yes_recommendation_cause" placeholder="Przyczyna problemu" v-if="question.yes_generate_recommendation" :disabled="!edit" /></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col s2">{{$t("inspection_procedures.type_procedure")}}</div>
                            <div class="col s4">
                                <select v-model="question.yes_recommendation_kind" :disabled="!edit">
                                    <option value="correction">{{$t("recommendations.correction")}}</option>
                                    <option value="fixing">{{$t("recommendations.repairs")}}</option>
                                    <option value="prevention">{{$t("recommendations.prevention")}}</option>
                                    <option selected="selected" value="emergency">{{$t("recommendations.emergency")}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col s2">{{$t("inspection_procedures.solution")}}</div>
                            <div class="col s10">
                                <div class="input-field"><input v-model="question.yes_recommendation_solution" placeholder="Proponowane rozwiązanie problemu" v-if="question.yes_generate_recommendation" :disabled="!edit" /></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" style="margin-top: 25px;margin-bottom: 25px !important;" v-if="place.questions && edit">
                <div class="col s2">
                    <a v-on:click="addQuestion()" class="waves-effect waves-light btn-small green">{{$t("inspection_procedures.add_question")}}</a>
                </div>
            </div>
            </template>
            <div class="row" style="text-align: left;">
                <div class="col m6 label">
                    <label>
                        <input type="checkbox" v-model="place.inner_inspections" :disabled="!edit"/>
                        <span>{{$t("inspection_procedures.inner_inspections")}}</span>
                    </label>
                </div>
            </div>
            <div class="row" style="text-align: left;">
                <div class="col m6 label">
                    <label>
                        <input type="checkbox" v-model="place.substance_usages" :disabled="!edit"/>
                        <span>{{$t("inspection_procedures.substances_usages")}}</span>
                    </label>
                </div>
            </div>
            <div class="row" style="text-align: left;">
                <div class="col m6 label">
                    <label>
                        <input type="checkbox" v-model="place.with_seal" :disabled="!edit"/>
                        <span>{{$t("inspection_procedures.seals")}}</span>
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col s6 offset-l6 l3">
                    <a v-on:click="cancel()" class="waves-effect waves-light btn-large cancelbutton" v-if="edit== true">{{$t('menu.buttons.cancel_changes')}}</a>
                </div>
                <div class="col s6 l3">
                    <a v-on:click="startEdit()" class="waves-effect waves-light btn-large emptygreen" v-if="edit == false && place.editable">{{$t('menu.buttons.edit')}}</a>
                    <a v-on:click="save()" class="waves-effect waves-light btn-large emptygreen" v-if="edit">
                        <div v-if="saving" class="preloader-wrapper small active">
                            <div class="spinner-layer spinner-red-only">
                                <div class="circle-clipper left">
                                    <div class="circle"></div>
                                </div>
                                <div class="gap-patch">
                                    <div class="circle"></div>
                                </div>
                                <div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                            </div>
                        </div>
                        {{saving == false ? $t('menu.buttons.save_changes') : ""}}
                    </a>
                </div>
            </div>
        </collapsible>
        </template>
       <!--  <collapsible title="ANALIZY ZAGROŻEŃ" :active="place.id != undefined">
        </collapsible> -->
    </div>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';
export default {
    data: function() {
        return {
            place_id: 0,
            loaded: false,
            error: false,
            edit: false,
            editcontacts: false,
            editdocuments: false,
            editplans: false,
            savingdocuments: false,
            savingplans: false,
            saving: false,

            standards: [{ value: "haccp", name: "HACCP" },
                { value: "iso", name: "ISO/FSSC22000" },
                { value: "brc_food", name: "BRC FOOD" },
                { value: "brc_storage", name: "BRC STORAGE nie dotyczy DISTRIBUTION" },
                { value: "brc_agent_broker", name: "BRC AGENT & BROKERS" },
                { value: "brc_packaging", name: "BRC PACKAGING  dotyczy PACKAGING MATERIALS" },
                { value: "ifs_food", name: "IFS FOOD" },
                { value: "ifs_logistic", name: "IFS LOGISTICS" },
                { value: "ifs_broker", name: "IFS BROKER" },
                { value: "other", name: "INNE" }
            ],
            building_types_list: [
                { "value": "offices", name: this.$t('place.details_form.office') },
                { value: "storage", name: this.$t('place.details_form.storage') },
                { value: "green", name: this.$t('place.details_form.green_spaces') },
                { value: "storage_p", name: this.$t('place.details_form.storage_yard') },
                { value: "tents", name: this.$t('place.details_form.shelter') },
                { value: "production", name: this.$t('place.details_form.manufacturing') },
                { value: "other", name: this.$t('place.details_form.other') },
                { value: "gastro", name: this.$t('place.details_form.gastronomy') },
                { value: "house", name: this.$t('place.details_form.detached_house') },
                { value: "estate", name: this.$t('place.details_form.multi_apartment_building') },
                { value: "trading", name: this.$t('place.details_form.commercial_facility') },
                { value: "basement", name: this.$t('place.details_form.basement') },
                { value: "garage", name: this.$t('place.details_form.garage_hall') },
                { value: "farm", name: this.$t('place.details_form.farmhouse') }
            ],
            neighbours: [{ value: "living", name: this.$t('place.details_form.living') },
                { value: "industrial", name: this.$t('place.details_form.industrial') },
                { value: "fields", name: this.$t('place.details_form.fields') },
                { value: "still_water", name: this.$t('place.details_form.still_water') },
                { value: "other", name: this.$t('place.details_form.other') }
            ],
            place: {
                status: "active",
                standards: [],
                neighbour_buildings: [],
                building_types: [],
                contacts: [],
                documents: []
            },
            question: "",
            cancelText: "",
            confirmText: ""
        }
    },
    props: {role: String, company_id: Number},
    beforeRouteLeave (to, from , next) {
      if(this.edit || this.editcontacts || this.editdocuments || this.editplans || this.$refs.devices?.anyEdited() || this.$refs.recommendations?.editing ){
          this.question = this.$t('menu.save_question');
          this.cancelText = this.$t('menu.buttons.save_cancel')
          this.confirmText = this.$t('menu.buttons.save_changes')
          this.$refs.question.open();
          this.callback = next;
      }else{
        next()
      }      
    },
    created() {
        // fetch the data when the view is created and the data is
        // already being observed
        this.customer_id = this.$route.params.customer_id
        if (this.$route.params.place_id == 'new') {
            this.edit = true
            this.loaded = true
            this.place = {
                name: '',
                displayedname: '',
                status: 'active',
                documents: [],
                contacts: [],
                interventions: [],
                tags: [],
                address: {
                    street: '',
                    city: ''
                }
            }
        } else {
            this.edit = false
            this.loaded = false
            this.place_id = this.$route.params.place_id
            this.fetchData()
        }
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchData'
    },
    methods: {
        fetchData() {
            var that = this;
            axios.get('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '.json').then(response => {
                that.place = response.data
                that.loaded = true
                var elems = document.querySelectorAll('.collapsible');
                // var instances = M.Collapsible.init(elems, { accordion: false });
                for (var order of that.place.orders) {
                    order.destroy = false
                    order.time_interval_days = order.time_interval / 86400000;
                    Object.defineProperty(order, 'time_interval_days', {
                        set: function(x) {
                            this.time_interval = x * 86400000;
                        },
                        get: function() {
                            return this.time_interval / 86400000;
                        }
                    });
                }
                that.place.zones_groups = _.keyBy(that.place.zones, 'id')
                for (var doc of that.place.documents) {
                    doc.old_date = doc.date;
                }
                for (var zone of that.place.zones) {
                    zone.edited_types = []
                    zone.saving_types = []
                    for (var order of zone.orders) {
                        order.destroy = false
                        Object.defineProperty(order, 'time_interval_days', {
                            set: function(x) {
                                this.time_interval = x * 86400000;
                            },
                            get: function() {
                                return this.time_interval / 86400000;
                            }
                        });
                    }
                    zone.order_groups = _.groupBy(zone.orders, 'device_category_id')
                    zone.criteria_groups = _.keyBy(zone.criteria, 'device_category_id')
                }
                that.init_collapsibles();
                window.scrollTo(0, 0);
                document.title = "Obiekt "+that.place.name;
            }).catch(e => {
                that.loaded = true;
                that.error = true;
            })

        },
        
        init_collapsibles: function() {},
        mounted() {
             // M.AutoInit();
        },
        removeQuestion(question) {
            if (_.isUndefined(question.id)) {
                this.place.questions.splice(this.place.questions.indexOf(question), 1)
            } else {
                question._destroy = true
            }
            this.$forceUpdate();
        },
        setFile: function(doc, name, file) {
            doc.file = file[0];
            this.$forceUpdate();
        },
        startEdit() {
            this.old_place = _.cloneDeep(this.place);
            this.edit = true;
        },
        cancel() {
            this.edit = false;
            this.place = _.cloneDeep(this.old_place);
        },
     
        addDocument() {
            if (this.editdocuments == false) this.editDocuments();
            this.place.documents.push({
                key: _.uniqueId('newdoc_'),
                old_date: moment().format("YYYY-MM-DD"),
                date: moment().format("YYYY-MM-DD"),
                doctype: "other",
                comment: ""
            })
        },
        editDocuments() {
            this.old_documents = _.cloneDeep(this.place.documents);
            this.editdocuments = true;
        },
        cancelEditDocuments() {
            this.editdocuments = false;
            this.place.documents = this.old_documents
        },
        saveContacts: async function(){
            this.savingcontacts = true
            var docs = 0;
            const formData = new FormData();
            for (var doc of this.place.contacts) {
                if (doc.id) formData.append('place[contacts_attributes][' + docs + '][id]', doc.id);
                formData.append('place[contacts_attributes][' + docs + '][name]', doc.name);
                formData.append('place[contacts_attributes][' + docs + '][position]', doc.position);
                formData.append('place[contacts_attributes][' + docs + '][phone]', doc.phone);
                formData.append('place[contacts_attributes][' + docs + '][phone_other]', doc.phone_other);
                formData.append('place[contacts_attributes][' + docs + '][display_on_app]', doc.display_on_app);
                if (doc.email) formData.append('place[contacts_attributes][' + docs + '][email]', doc.email);
                if (doc.destroy) formData.append('place[contacts_attributes][' + docs + '][_destroy]', true);
                docs += 1;
            }
            try{
                var response = await axios.put('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '.json', formData)
                this.savingcontacts = false;
                this.editcontacts = false;
                this.errors = {};
                this.place.contacts = _.cloneDeep(response.data.contacts)
            }catch(err){
                if( err.response ){
                    this.place.contacts = _.cloneDeep(err.response.data.contacts)
                }
            }
        },
        saveDocuments: async function(){
            this.savingdocuments = true
            var docs = 0;
            const formData = new FormData();
            for (var doc of this.place.documents) {
                if (doc.id) formData.append('place[documents_attributes][' + docs + '][id]', doc.id);
                formData.append('place[documents_attributes][' + docs + '][date]', doc.date);
                formData.append('place[documents_attributes][' + docs + '][name]', doc.name);
                formData.append('place[documents_attributes][' + docs + '][doctype]', doc.doctype);
                formData.append('place[documents_attributes][' + docs + '][comment]', doc.comment);
                if (doc.file) formData.append('place[documents_attributes][' + docs + '][attachment]', doc.file);
                if (doc.destroy) formData.append('place[documents_attributes][' + docs + '][_destroy]', true);
                docs += 1;
            }
            try{
                var response = axios.put('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '.json', formData)
                this.savingdocuments = false;
                this.editdocuments = false;
                this.errors = {};
                this.place.documents = _.cloneDeep(response.data.documents);
            }catch(err){

            }
        },
        okClicked: function(){
            if(this.edit){
                this.save()
            }
            if(this.editcontacts){
                this.saveContacts()
            }
            if(this.editdocuments){
                this.saveDocuments()
            }
            if(this.editplans){
                this.savePlans()
            }
            if(this.$refs.recommendations.editing){
                this.$refs.recommendations.save_changes()
            }
            this.callback()
        },
        cancelClicked: function(){
            this.callback();
        },
        cancelEditContacts: function() {
            this.place.contacts = this.old_contacts;
            this.editcontacts = false;
        },
        editContacts: function() {
            this.old_contacts = _.cloneDeep(this.place.contacts);
            this.editcontacts = true;
        },
        addContact: function() {
            if (this.editcontacts == false) {
                this.editContacts()
            }
            this.place.contacts.push({ "display_on_app": false, "name": "", "email": "", "phone": "", "phone_other": "", "position": "" })
        },
        removeContact: function(doc) {
            if (_.isUndefined(doc.id)) {
                this.place.contacts.splice(this.place.contacts.indexOf(doc), 1)
            } else {
                doc.destroy = true;
                const formData = new FormData();
                formData.append('place[contacts_attributes][0][id]', doc.id);
                formData.append('place[contacts_attributes][0][_destroy]', true);
                axios.put('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '.json', formData).then(response => {
                    this.savingcontacts = false;
                    this.editcontacts = false;
                    this.errors = {};
                    this.place.contacts = _.cloneDeep(response.data.contacts)
                })
                this.$forceUpdate();
            }
        },
        removeDocument: function(doc) {
            if (_.isUndefined(doc.id)) {
                this.place.documents.splice(this.place.documents.indexOf(doc), 1)

            } else {
                doc._destroy = true;
                const formData = new FormData();
                formData.append('place[documents_attributes][0][id]', doc.id);
                formData.append('place[documents_attributes][0][_destroy]', true);
                axios.put('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '.json', formData).then(response => {
                    this.savingcontacts = false;
                    this.editcontacts = false;
                    this.errors = {};
                    this.place.documents.splice(this.place.documents.indexOf(doc), 1)
                })
                this.$forceUpdate();
            }
        },
        rmObject() {
            axios.delete('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '.json').then(response => {
                this.$router.push({ name: 'customer', params: { customer_id: this.$route.params.customer_id } })
            })
        },
        addQuestion() {
            this.place.questions.push({})
            this.$forceUpdate()
        },
        startEditField(){
            if(_.isNil(this.place.displayedname) || _.isEmpty(this.place.displayedname)){
                if(!_.isNil(this.place.name) && !_.isEmpty(this.place.name)) this.place.displayedname = _.clone(this.place.name)
            }
            if(_.isNil(this.place.name) || _.isEmpty(this.place.name)){
                if(!_.isNil(this.place.displayedname) && !_.isEmpty(this.place.displayedname)) this.place.name = _.clone(this.place.displayedname)
            }
        },
        save() {
            var that = this;
            this.saving = true;
            if (this.$route.params.place_id != 'new') {
                if(_.isNil(this.place.displayedname) || _.isEmpty(this.place.displayedname)){
                    if(!_.isNil(this.place.name) && !_.isEmpty(this.place.name)) this.place.displayedname = _.clone(this.place.name)
                }
                if(_.isNil(this.place.name) || _.isEmpty(this.place.name)){
                    if(!_.isNil(this.place.displayedname) && !_.isEmpty(this.place.displayedname)) this.place.name = _.clone(this.place.displayedname)
                }
                console.log(this.place);
                axios.put('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '.json', {
                    "place": {
                        "displayedname": this.place.displayedname,
                        "tags": this.place.tags,
                        "status": this.place.status,
                        "name": this.place.name,
                        "info": this.place.info,
                        "contacts_attributes": this.place.contacts,
                        "total_area": this.place.total_area,
                        "total_area_units": this.place.total_area_units,
                        "building_area": this.place.building_area,
                        "building_area_units": this.place.building_area_units,
                        "distance": this.place.distance,
                        "economic_activity": this.place.economic_activity,
                        "standards": this.place.standards,
                        "neighbour_buildings": this.place.neighbour_buildings,
                        "building_types": this.place.building_types,
                        "address_attributes": this.place.address,
                        "questions": this.place.helping_questions,
                        "helping_questions_attributes": this.place.questions,
                        "inner_inspections": this.place.inner_inspections,
                        "substance_usages": this.place.substance_usages,
                        "with_seal": this.place.with_seal,
                        "estimated_time": this.place.estimated_time,
                        "misc": this.place.misc
                    }
                }).then(response => {
                    that.place = response.data
                    that.loaded = true
                    that.saving = false;
                    that.edit = false;
                    that.editcontacts = false;

                })
            } else {
                axios.post('/customers/' + this.$route.params.customer_id + '/places.json', {
                    "place": {
                        "displayedname": this.place.displayedname,
                        "tags": this.place.tags,
                        "name": this.place.name,
                        "info": this.place.info,
                        "contacts_attributes": this.place.contacts,
                        "total_area": this.place.total_area,
                        "total_area_units": this.place.total_area_units,
                        "building_area": this.place.building_area,
                        "building_area_units": this.place.building_area_units,
                        "distance": this.place.distance,
                        "economic_activity": this.place.economic_activity,
                        "standards": this.place.standards,
                        "neighbour_buildings": this.place.neighbour_buildings,
                        "building_types": this.place.building_types,
                        "address_attributes": this.place.address,
                        "questions": this.place.questions,
                        "inner_inspections": this.place.inner_inspections,
                        "substance_usages": this.place.substance_usages,
                        "with_seal": this.place.with_seal,
                        "estimated_time": this.place.estimated_time,
                        "misc": this.place.misc
                    }
                }).then(response => {
                    that.place = response.data
                    that.place_id = that.place.id
                    that.loaded = true
                    that.saving = false;
                    that.edit = false;
                    that.editcontacts = false;
                    this.$router.push({ name: 'place', params: { customer_id: this.$route.params.customer_id, place_id: that.place.id } })
                })
            }
        }
    },
    computed: {
        getDocuments: function() {
            return _.chain(this.place.documents).filter(function(doc) {
                return doc.doctype != "plan";
            }).sort(function(a, b){ return moment(a.old_date, 'YYYY-MM-DD').unix() - moment(b.old_date, 'YYYY-MM-DD').unix() }).value();
        },
    }
}
</script>
<style scoped>
/deep/ .collapsible-body {
    border-bottom: 0px !important;
}

.redframe {
    text-align: left;
    background-color: rgb(194, 32, 38);
    margin-bottom: 20px !important;
}

.center {
    padding: 15px;
}

.btn {
    border-radius: 8px !important;
    color: black;
}

.input-field {
    padding-bottom: 0rem;
    padding-top: 0rem;
}

.input-field>.input-field {
    padding-bottom: 0rem;
    padding-top: 0rem;
}

.input-field>input {
    padding-bottom: 0rem;
    padding-top: 0rem;
}

.preloader-wrapper /deep/ {
    margin-top: 10px !important;
}

/deep/ .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.solidgreen {
    background-color: #00CC66 !important;
}

/deep/ .collapsible-header, .collapsible-header:focus{
    background-color: #bebbbb !important;
    text-transform: uppercase;
}

/deep/ .active>.collapsible-header {
    background-color: #C22026 !important;
}

/deep/ .collapsible {

    margin-left: 15px;
    margin-right: 15px;
    box-shadow: 0 0px 0px;
    border: 0px;
}

.nested-collapsible {
    padding-right: 0px;
    padding-bottom: 0px;
    border-bottom-width: 0px;
}

/deep/ .nested-collapsible .collapsible {
    margin-right: 0px;
}

/deep/ .collapsible-header {
    background-color: #8A8D91;
    text-transform: uppercase;
}

/deep/ .active>.collapsible-header {
    background-color: #C22026;
}

/deep/ .collapsible-body>.input-field {
    margin-bottom: 0rem;
    margin-top: 0rem;
}

.row .input-field {
    margin-bottom: 0rem;
    margin-top: 0rem;
}

.row {
    margin-bottom: 0rem;
}

/deep/ .collapsible {
    margin-bottom: 0rem;
}

/deep/ .collapsible-header>i {
    position: absolute !important;
    right: 2%;
}

/deep/ .collapsible-body .collapsible-header>i {
    position: absolute !important;
    right: 5%;
}

.active>.collapsible-header>i {
    -ms-transform: rotate(180deg);
    /* IE 9 */
    -webkit-transform: rotate(180deg);
    /* Chrome, Safari, Opera */
}

select {
    display: block;
    background-color: white !important;
    border-radius: 4px !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
    padding-left: 5px !important;
    height: 35px !important;
}

.preloader-wrapper {
    margin-top: 10px !important;
}

[type="checkbox"]:checked+span:not(.lever):before {
    border-right: 2px solid #000;
    border-bottom: 2px solid #000;
}

.rightlabel /deep/ {
    text-align: right;
    line-height: 2.5;
}

.red {
    background-color: #C22026 !important;
    border-color: #C22026 !important;
}

/deep/ .emptygreen {
    background-color: #FFF !important;
}

select:disabled {
    opacity: 1.0;
}

.col .row .col div {
    display: flex;
    max-height: 60px;
}

/deep/ .collapsible-body .collapsible li {
    border-bottom-width: 0px !important;
    padding-bottom: 0px !important;
    background-color: white;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    line-height: 1.5;
    background-color: #fff;
    border-bottom: 1px solid #ddd;
    border-top: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-left: 1px solid #ddd;
    box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);
}

/deep/ .collapsible-body .collapsible-header {
    right: 8%;
    background-color: white !important;
}

/deep/ select {
    display: block;
    background-color: white !important;
    border-radius: 4px !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
    padding-left: 5px !important;
    height: 35px !important;
}
@media print {
    /deep/ .collapsible-header{
        display: none;
    }
    /deep/ .collapsible:has(.analyses){
        display: block !important;
    }
    /deep/ .hiddenprint {
        display: none;
    }
}
.errors input{
    border-color: #C22026 !important;
    margin-bottom: 0px !important;
}
.errors span{
    color: #C22026;
}
</style>
